module.exports = __webpack_public_path__ + "media/images/uvod_foto-ccbb9b13.png";